import { FormField } from 'ui/formField';
import { FlexSpacer } from 'ui/flexSpacer';
import { View16 } from 'ui/icons/aurora/16px/View16';
import { Table } from 'ui/table';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { NewFieldsTable } from 'modules/catalogFieldTypes/components/NewFieldsTable';
import { FileDropzone } from 'ui/fileDropzone';
import { getSampleDataFromCsv } from 'modules/catalogFieldTypes/helpers';
import {
  CSVPreviewContainer,
  CSVUploaderContainer,
  StyledErrorBanner,
  StyledWarningBanner,
} from './CatalogForm.styled';
import { CSV_WARNINGS } from '../constants';

// type Props = {
//   isCatalogCollectionsFlagOn: boolean,
//   rowData: any[],
//   columnData: any[],
//   csvFileError?: string,
//   csvFileName?: string,
//   onCsvPreview: (evt: { files: File[] }) => void,
//   keyWarning?: boolean,
//   headerValueWarning?: boolean,
//   newFields: any[],
// };

export const CatalogCsvUploader = (props) => {
  const {
    isCatalogCollectionsFlagOn,
    rowData,
    columnData,
    csvFileName,
    onCsvPreview,
    keyWarning,
    headerValueWarning,
    csvFileError,
    newFields,
  } = props;

  const showWarning = keyWarning || headerValueWarning;

  const errors = {
    keyWarning,
    headerValueWarning,
  };

  const warnings = CSV_WARNINGS.map((g, i) => {
    const isDisplayed = errors[g.isDisplayed];
    return {
      ...g,
      key: i,
      isDisplayed,
    };
  });

  const previewTable = (
    <FlexSpacer flexDirection="column" alignItems="stretch">
      <FlexSpacer>
        <View16 />
        No new fields found. Previewing the first 5 rows for {csvFileName}
      </FlexSpacer>
      <Table>
        <TableHeader columns={columnData} />
        <TableRows rows={rowData} columns={columnData} />
      </Table>
    </FlexSpacer>
  );

  const previewFieldsOrTable = () =>
    newFields && newFields.length > 0 ? (
      <NewFieldsTable rowData={getSampleDataFromCsv({ newFields, rowData })} />
    ) : (
      <>{previewTable}</>
    );

  return (
    <div>
      <CSVUploaderContainer>
        <FormField
          labelText=""
          helpText={
            <>
              Your CSV cannot be longer than 1,000 rows (not including header row). Each row must be
              less than 30kb. You must have a column named "key". "key" is case-insensitive (i.e.,
              "Key" is also valid).
            </>
          }
        >
          <FileDropzone
            accept={{ 'text/csv': ['.csv'] }}
            onUpload={onCsvPreview}
            multiple={false}
          />
        </FormField>
      </CSVUploaderContainer>
      {csvFileError && <StyledErrorBanner>{csvFileError}</StyledErrorBanner>}
      {columnData && columnData.length > 0 && showWarning && (
        <StyledWarningBanner>
          {warnings.map((warning) => (
            <div key={warning.key}>{warning.content}</div>
          ))}
        </StyledWarningBanner>
      )}
      {rowData && rowData.length > 0 && !showWarning && (
        <CSVPreviewContainer>
          {isCatalogCollectionsFlagOn ? previewFieldsOrTable() : previewTable}
        </CSVPreviewContainer>
      )}
    </div>
  );
};

export default CatalogCsvUploader;
CatalogCsvUploader.defaultProps = {
  newFields: [],
};
